/**
 * Note: all the case's in the enum's use 
 * only camelCase (not CapitalCamelCase) for
 * compatibility with the PHP enum's
 */

/**
 * @see app/common/enums/reactApp/CartHtmlIdentifierEnum
 */
export enum CartHtmlIdentifierEnum
{
    wrapId = 'cart-order-wrap',
}

/**
 * @see app/common/enums/reactApp/ShowableProductCardHtmlIdentifierEnum
 */
export enum ShowableProductCardHtmlIdentifierEnum
{
    wrapId = 'showable-product-card',
    wrapProductTypeIdAttributeName = 'product-type-id',
    wrapBaseCardIdAttributeName = 'base-card-id',
    wrapRealModifierIdAttributeName = 'real-modifier-id',
    wrapIsManuallySetModifierAttributeName = 'is-manually-set-modifier',
    buyViaDolyameWrapId = 'buy-via-dolyame-wrap',
    textileSwitcherWrapId = 'textile-switcher-wrap',
    priceBlockWrapId = 'price-block-wrap',
    stockWrapId = 'stock-wrap',
    buyViaCreditWrapId = 'buy-via-credit-wrap',
    deliveryWrapId = 'delivery-wrap',
    mainActionGroupWrapId = 'main-action-group-wrap',
    popularCharacterListWrapId = 'popular-character-list-wrap',
    ratingBlockWrapId = 'rating-block-wrap',
    ratingBlockWrapNumberStarsAttributeName = 'rating-number-stars',
    subActionGroupWrapId = 'sub-action-group-wrap',
    badgeListWrapId = 'badge-list-wrap',
    mainCharacterListWrapId = 'main-character-list-wrap',
    realModifierSwitcherWrapId = 'real-modifier-switcher-wrap',
    countReviewsAttributeName = 'count-reviews',
    countOrdersAttributeName = 'count-orders',
    articulWrapId = 'articul-wrap',
    buyBlockWrapId = 'buy-block-wrap',
    sizeSelectorWrapId = 'size-selector-wrap',
    tabPanelPriceBlock = 'tab-panel-price-block',
    productHeader = 'product-header-wrap',
    additionalProductsWrapId = 'additional-products-wrap',
    additionalProductsContainerId = 'additional-products-container',
    additionalRealModifierWrapId = 'additional-real-modifiers-wrap',
}

/**
 * @see app/common/enums/reactApp/ProductCardDetailLevelEnum
 */
export enum ProductCardDetailLevelEnum
{
    l1 = 'ProductCardV1',
    l2 = 'ProductCardV2',
    l3 = 'ProductCardV3',
    l4 = 'ProductCardV4',
    l5 = 'ProductCardV5',
    l6 = 'ProductCardV6',
    l7 = 'ProductCardV7',
}

/**
 * @see app/common/enums/CommonLabelsEnum
 */
export enum CommonLabelsEnum
{
    productHasNoPrice = 'Временно нет в наличии',
    productAsGift = 'Бесплатно',
    productDiscontinued = 'Снят с производства',
}

/**
 * @see app/common/enums/catalog/ModifierProcessingStrategyTypeEnum
 */
export enum ModifierProcessingStrategyTypeEnum
{
    replacement = 1,
    supplement = 2,
}

/**
 * @see app/common/enums/catalog/VirtualModifierSwitcherTypeEnum
 */
export enum VirtualModifierSwitcherTypeEnum
{
    textile = 1,
}

/**
 * @see app/common/enums/delivery/DeliveryObjectTypeEnum
 */
export enum DeliveryObjectTypeEnum
{
    product = 1,
    modifiedProduct = 2,
}

/**
 * @see app/common/enums/catalog/ProductTypeEnum
 */
export enum ProductTypeEnum
{
    card = 1,
    realModifier = 2,
    virtualModifier = 3,
}

/**
 * @see app/common/models/common/PriceType
 */
export enum PriceTypeEnum 
{
    sale = 1,
    old = 2,
}

/**
 * @see app/common/enums/catalog/ModifierTypeEnum
 */
export enum ModifierTypeEnum
{
    product = 1,
    virtualSign = 2,
    realSign = 3,
    virtualData = 4,
    realData = 5,
}

/**
 * @see app/common/enums/rs/OrderRequestStageTypeEnum.php
 */
export enum OrderRequestStageTypeEnum
{
    registered = 1,
    inProcessing = 2,
    firstCommit = 3,
}

/**
 * @see app/common/enums/rs/OrderRequestPayServiceStatusTypeEnum.php
 */
export enum OrderRequestPayServiceStatusTypeEnum
{
    init = 1,
    waiting = 2,
    success = 3,
    cancel = 4,
    error = 5,
}

/**
 * @see app/common/enums/rs/DeliveryTypeEnum.php
 */
export enum DeliveryTypeEnum
{
    carrier = 1,
    pickupFromSdek = 2,
}

/**
 * @see app/common/enums/rs/PaymentTypeEnum.php
 */
export enum PaymentTypeEnum
{
    /**
     * Наличными или картой курьеру
     */
    cash = 1,

    /**
     * Онлайн на сайте (через Яндекс.Кассу)
     */
    online = 2,

    /**
     * Яндекс.Пэй (полная оплата)
     */
    yandexPayFullPayment = 3,

    /**
     * Яндекс.Пэй (сплит-оплата)
     */
    yandexPaySplit = 4,

    /**
     * Долями
     */
    dolyame = 5,

    /**
     * Онлайн-оплата через Яндекс.Кассу в рассрочку
     * @deprecated 0.24 **Внимание!** данный метод не имеет
     * реализации в БЛ, т.к. на момент переноса не работал на
     * текущем проекте son.ru
     * 
     * Для его включения, пожалуйста, убедитесь, что вы изучили
     * механику обработки заявок:
     * docs/testing/manual-test-guides/order-request.md
     * И **добавили БЛ для данного типа**
     * (и написали авто-тесты, если они присутствуют на момент реализации)
     */
    onlineCredit = 6,
}

/**
 * (Собственный enum React-приложения)
 * 
 * Режимы источника для агрегата ShowableCart
 * (ShowableCart.sourceMode)
 */
export enum ShowableCartSourceModeEnum
{
    /**
     * Источник данных: cookie и сессия текущего пользователя (предзаказ)
     */
    preOrder = 1,

    /**
     * Источник данных: оформленный заказ из базы данных
     * (для разрешенных пользователю по cookie + сессии (clientOrderIds),
     * либо по спец. режиму менеджера (сессия из CMS))
     */
    order = 2,
}

/**
 * @see app/common/enums/rs/IntegrationRecordTypeEnum.php
 */
export enum IntegrationRecordTypeEnum
{
    pay = 1,
    delivery = 2,
    crm = 3,
}

/**
 * @see app/common/enums/common/BadgeTypeEnum.php
 */
export enum BadgeTypeEnum
{
    discount = 1,
    gift = 2,
    fastDelivery = 3,
}

/**
 * @see app/common/enums/catalog/ProductSaleStatusTypeEnum
 */
export enum ProductSaleStatusTypeEnum
{
    notInStock = 0,
    inStock = 1,
    discontinued = 2,
    underOrder = 3,
}